import { render, staticRenderFns } from "./myProfileHeader.vue?vue&type=template&id=0f397e6c&scoped=true"
import script from "./myProfileHeader.vue?vue&type=script&lang=js"
export * from "./myProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./myProfileHeader.vue?vue&type=style&index=0&id=0f397e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f397e6c",
  null
  
)

export default component.exports